import React from 'react';
import { useTranslation } from 'react-i18next';

import { Input, InputType } from '@modernhealth/vital-components';

import { FloatingLabel } from './FloatingLabel';

interface Props {
    questionId: string;
    questionText?: string;
    response: string;
    handleResponseChange: (questionId: string, value: string) => void;
}

export const ReviewInputFullText: React.FC<Props> = ({
    questionId,
    questionText,
    response,
    handleResponseChange,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <FloatingLabel>{t(questionText as string)}</FloatingLabel>
            <Input
                fieldId={questionId}
                type={InputType.TextArea}
                label=""
                onChange={value => handleResponseChange(questionId, value as string)}
                value={response}
                height={70}
            />
        </>
    );
};
